module.exports = __webpack_public_path__ + "img/ic_insights_opened.98243836.png";